import React, { useMemo } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import { Icon } from '@fiverr-private/fit';
import { r_comment } from '@fiverr-private/icons';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n, translate } from '@fiverr-private/i18n-react';

/**
 * @param {import('../../../types').Language['code']} codeName
 * @returns {string}
 */
const getLanguage = (codeName) => {
    const { locale } = getContext();
    return translate(`languages.codes.${codeName.toLowerCase()}`, { locale });
};

/** @type {import('../../../types').LanguageLevel} */
export const LanguageLevel = {
    BASIC: 'BASIC',
    CONVERSATIONAL: 'CONVERSATIONAL',
    FLUENT: 'FLUENT',
    NATIVE_OR_BILINGUAL: 'NATIVE_OR_BILINGUAL',
};

/** @type {React.FC<{className?: string; languages: import('../../../types').Language[]}>} */
export const Languages = ({ className, languages = [] }) => {
    const validLanguages = useMemo(() => languages.filter((item) => item.level !== LanguageLevel.BASIC), [languages]);
    if (isEmpty(validLanguages)) {
        return null;
    }

    return (
        <div className={classnames(className, 'flex-center flex-start')}>
            <Icon color={grey_1100}>{r_comment}</Icon>
            <span className="languages m-l-8">
                <I18n k="freelancer_page.languages.speaks" />{' '}
                {validLanguages.map((lang) => getLanguage(lang.code)).join(', ')}
            </span>
        </div>
    );
};
